module.exports = __webpack_public_path__ + "static/media/air1.468d6fb0.jpg";